import { call, put, race, take, takeEvery } from 'redux-saga/effects';
import { accountsBalancesActions } from '../accounts-balances';
import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './investmentHoldingsV2Actions';
import { getLastSyncDate } from './investmentHoldingsV2Selectors';
import { mkInvestmentHoldingV2 } from './investmentHoldingsV2Types';

const mkResourceConfig = (props) =>
  resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'investment holdings',
    resourceBaseUrl: '/v2/investments/holdings',
    getLastSyncDate,
    transformResponseToResources: (response) =>
      response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentHoldingV2(data)),
    ...props,
  });

export function* investmentHoldingsCalcSucceedActionWatcher() {
  yield takeEvery(actions.investmentHoldingsCalcSuccess, function* investmentHoldingsCalcSuccess() {
    yield put(accountsBalancesActions.getAccountsBalances());
  });
}

export function* investmentHoldingsCalcActionWatcher() {
  const resourceConfig = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'investment holdings calc',
    resourceBaseUrl: '/v2/investments/holdings/manual-accounts-holdings',
    successAction: actions.investmentHoldingsCalcSuccess,
    failureAction: actions.investmentHoldingsCalcFailure,
  });
  while (true) {
    yield race([
      take(actions.createInvestmentHoldingV2Success),
      take(actions.updateInvestmentHoldingV2Success),
      take(actions.deleteInvestmentHoldingV2Success),
      //  take(actions.getInvestmentHoldingsV2Success),
    ]);
    yield call(resourceSagaUtils.qcsSyncCreateResource, resourceConfig, actions.investmentHoldingsCalc());
  }
}

export function* getInvestmentHoldingsV2ActionWatcher() {
  const resourceConfig = mkResourceConfig({
    successAction: actions.getInvestmentHoldingsV2Success,
    failureAction: actions.getInvestmentHoldingsV2Failure,
  });
  yield resourceSagaUtils.takeAndDebounce(
    actions.getInvestmentHoldingsV2,
    resourceSagaUtils.qcsSyncGetResources,
    resourceConfig,
  );
}

export function* createInvestmentHoldingV2ActionWatcher() {
  const resourceConfig = mkResourceConfig({
    successAction: actions.createInvestmentHoldingV2Success,
    failureAction: actions.createInvestmentHoldingV2Failure,
  });
  yield takeEvery(actions.createInvestmentHoldingV2, resourceSagaUtils.qcsSyncCreateResource, resourceConfig);
}

export function* updateInvestmentHoldingV2ActionWatcher() {
  const resourceConfig = mkResourceConfig({
    successAction: actions.updateInvestmentHoldingV2Success,
    failureAction: actions.updateInvestmentHoldingV2Failure,
  });
  yield takeEvery(actions.updateInvestmentHoldingV2, resourceSagaUtils.qcsSyncUpdateResource, resourceConfig);
}

export function* deleteInvestmentHoldingV2ActionWatcher() {
  const resourceConfig = mkResourceConfig({
    successAction: actions.deleteInvestmentHoldingV2Success,
    failureAction: actions.deleteInvestmentHoldingV2Failure,
  });
  yield takeEvery(actions.deleteInvestmentHoldingV2, resourceSagaUtils.qcsSyncDeleteResource, resourceConfig);
}

export function* batchInvestmentHoldingsV2ActionWatcher() {
  const resourceConfig = mkResourceConfig(
    actions.batchInvestmentHoldingsV2Success,
    actions.batchInvestmentHoldingsV2Failure,
  );
  yield takeEvery(actions.batchInvestmentHoldingsV2, resourceSagaUtils.qcsSyncUpdateResources, resourceConfig);
}

export default [
  investmentHoldingsCalcSucceedActionWatcher,
  investmentHoldingsCalcActionWatcher,
  batchInvestmentHoldingsV2ActionWatcher,
  getInvestmentHoldingsV2ActionWatcher,
  createInvestmentHoldingV2ActionWatcher,
  updateInvestmentHoldingV2ActionWatcher,
  deleteInvestmentHoldingV2ActionWatcher,
];
